(function ($) {
  DJ.addBehavior('iframeResizer', '.iframe', {
    attach: function () {
      const iframe = this.querySelector('iframe');
      iFrameResize({
        log: true,
        heightCalculationMethod: 'bodyOffset'
      }, iframe);
    }
  });
})(jQuery);
